import { hasAdminRights } from "permissions/helpers/shared";
import { isKybAccepted } from "helpers/shared/kyb";
import { isKycAccepted } from "helpers/shared/kyc";

import {
  BankCardResDto,
  GetCompanyByIdResponseDto,
  UserProfileResponseDto,
} from "utils/swagger_react_query";

export const shouldFetchInternalBankAccounts = (
  currentUser: UserProfileResponseDto | undefined | null,
  currentCompany: GetCompanyByIdResponseDto | undefined | null,
) => {
  const isAdmin = hasAdminRights(currentUser);
  if (isAdmin) {
    return !!isKybAccepted(currentCompany);
  }
  return !!isKycAccepted(currentUser);
};

export const hasAccessToInternalBankAccount = (
  currentUser: UserProfileResponseDto | null | undefined,
  currentCompany: GetCompanyByIdResponseDto | null | undefined,
  bankCards?: BankCardResDto[] | null,
) => {
  // NOTE::: Determine if the company has access to the internal bank account.
  const isAdmin = hasAdminRights(currentUser);
  const hasBankCards = !!bankCards?.length;
  const isAuthorizedSigner = (currentUser?.activeCompanyUser as any)?.isAuthorizedSigner as boolean;
  const hasEmployeePersonalBankAccount =
    !isAdmin && currentUser?.activeCompanyUser?.hasPersonalBankAccount;

  if (isAdmin) {
    return !!isKybAccepted(currentCompany) && (hasBankCards || isAuthorizedSigner);
  }
  return !!isKycAccepted(currentUser) && (hasBankCards || hasEmployeePersonalBankAccount);
};
